import { Link as RouterLink } from 'react-router-dom';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

export function shouldShowAdminTestLink(): boolean {
  if (process.env.REACT_APP_SHOW_ADMIN_TEST_LINK === 'true') return true;
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host.endsWith('.pages.dev') || host.endsWith('.cloudflarepages.com');
}

export default function AdminTestLinkBanner() {
  if (!shouldShowAdminTestLink()) return null;

  return (
    <Alert
      severity="info"
      sx={{ mb: 2 }}
      action={
        <Stack direction="row" spacing={1} useFlexGap sx={{ flexShrink: 0 }}>
          <Button component={RouterLink} to="/admin/login" size="small" color="inherit">
            Admin login
          </Button>
          <Button component={RouterLink} to="/admin/dashboard" size="small" variant="outlined" color="inherit">
            Admin dashboard
          </Button>
        </Stack>
      }
    >
      Temporary Cloudflare test links — remove before production launch.
    </Alert>
  );
}
